const SQFT_PER_ACRE = 43560;
const ACRE_DISPLAY_FLOOR = 0.25;

const positive = (value) => {
  const number = Number(value);
  return Number.isFinite(number) && number > 0 ? number : null;
};

const firstPositive = (...values) => {
  for (const value of values) {
    const number = positive(value);
    if (number) return number;
  }
  return null;
};

const trimZeros = (text) => (text.includes(".") ? text.replace(/\.?0+$/, "") : text);

export const formatLotSize = ({ acres, sqft } = {}) => {
  const knownAcres = positive(acres);
  const knownSqft = positive(sqft);
  const inAcres = knownAcres ?? (knownSqft ? knownSqft / SQFT_PER_ACRE : null);
  if (!inAcres) return "";
  if (inAcres >= ACRE_DISPLAY_FLOOR) {
    return `${Number(inAcres.toFixed(2)).toLocaleString("en-US", {
      maximumFractionDigits: 2,
    })} Acres`;
  }
  const inSqft = knownSqft ?? Math.round(inAcres * SQFT_PER_ACRE);
  return `${Math.round(inSqft).toLocaleString("en-US")} Sqft`;
};

// MLS-sourced rows have no inventory row. The list queries do not select
// mlsListingKey, so a missing Inv_Id is the signal that always holds.
const isMlsIntroduction = (details) => !details?.Inv_Id;

const landLotSize = (details) =>
  Number(details.Acre_Sqft) === 2
    ? formatLotSize({ sqft: details.TotalAcre })
    : formatLotSize({ acres: details.TotalAcre });

export const introLotSize = (details, { isLand = false } = {}) => {
  if (!details) return "";
  if (isMlsIntroduction(details)) {
    // For MLS rows the API puts the square footage in Acre_Sqft.
    return formatLotSize({
      acres: firstPositive(details.ListingLotSizeAcres, details.TotalAcre),
      sqft: firstPositive(
        details.ListingLotSizeSquareFeet,
        details.LotSz,
        details.Acre_Sqft,
      ),
    });
  }
  if (isLand) return landLotSize(details);
  const lotAcres = firstPositive(details.LotSz, details.lotSize);
  return lotAcres
    ? formatLotSize({ acres: lotAcres })
    : landLotSize(details);
};

export const positiveCount = (value) => {
  const number = positive(value);
  return number ? trimZeros(String(number)) : "";
};
